<template>
	<div class="room-filters">
		<AppList :items="roomsElements" >
			<template #toggle-type="{item}">
				<div class="row space-between centered list-row">
					<p>{{ item.title }}</p>
					<div class="buttons-container">
						<div class="button-container" @click="toggleFreeFilter" :class="{active: roomsStore.showFreeTables && !roomsStore.showOccupiedTables}">{{ getString('free_table') }}</div>
						<div class="button-container" @click="toggleOccupiedFilter" :class="{active: roomsStore.showOccupiedTables && !roomsStore.showFreeTables}">{{ getString('occupied') }}</div>
					</div>
				</div>
			</template>
			<template #toggle-filter="{item}">
				<div class="row space-between centered list-row">
					<p>{{ item.title }}</p>
					<div class="buttons-container">
						<div class="button-container" @click="item.clickCallback" :class="{active: item.active}">{{ item.buttonText }}</div>
					</div>
				</div>
			</template>
		</AppList>
	</div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import {useRoomsStore, useRoomsOrdersStore, useUserStore} from "@/console-new/stores";
import {useLanguageStore} from "@/shared/stores";
import AppButton from "@/console-signup-speedy/App.vue";

export default {
	setup() {
		const roomsStore = useRoomsStore();
		const roomsOrdersStore = useRoomsOrdersStore();
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		return {roomsStore, getString: languageStore.getString, roomsOrdersStore, userStore};
	},
	name: "RoomFilters",
	components: {AppButton, AppList},
	emits: ["close"],
	data() {
		return {

		}
	},
	computed: {
		roomsElements() {
			return [
				{
					title: this.getString("element_status"),
					customSlot: "toggle-type",
				},
				{
					title: this.getString("asked_assistance"),
					buttonText: this.getString("assistance"),
					customSlot: "toggle-filter",
					active: this.roomsOrdersStore.askedAssistanceFilter,
					clickCallback: this.toggleAssistanceFilter,
				},
				{
					title: this.getString("reverse_order"),
					buttonText: this.getString("reverse"),
					customSlot: "toggle-filter",
					active: this.roomsStore.reverseOrder,
					clickCallback: () => {
						this.roomsStore.reverseOrder = !this.roomsStore.reverseOrder;
						this.$emit("close");
					},
				}
			]
		}
	},
	methods: {
		toggleFreeFilter() {
			if(this.roomsStore.showOccupiedTables) {
				if(this.roomsStore.showFreeTables) {
					this.roomsStore.showOccupiedTables = false;
				} else {
					this.roomsStore.showFreeTables = true;
				}
			} else {
				this.roomsStore.showOccupiedTables = true;
			}
			this.$emit("close");
		},
		toggleOccupiedFilter() {
			if(this.roomsStore.showFreeTables) {
				if(this.roomsStore.showOccupiedTables) {
					this.roomsStore.showFreeTables = false;
				} else {
					this.roomsStore.showOccupiedTables = true;
				}
			} else {
				this.roomsStore.showFreeTables = true;
			}
			this.$emit("close");
		},
		toggleAssistanceFilter() {
			this.roomsOrdersStore.askedAssistanceFilter = !this.roomsOrdersStore.askedAssistanceFilter;
			this.$emit("close");
		}
	}
}
</script>

<style scoped lang="scss">
.list-row {
	gap: 10px;
}
.buttons-container {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 10px;
	margin-left: auto;

	.button-container {
		padding: 8px 10px;
		border-radius: 13px;
		cursor: pointer;
		border: 1px solid var(--color-primary);
		color: var(--color-primary);
		font-size: 14px;
		font-weight: 500;

		&.active {
			background-color: var(--color-active-button);
			color: var(--color-active-button-text);
		}
	}
}
</style>